if(!__webpack_require__.federation){
	__webpack_require__.federation = {
		initOptions: {"name":"empresas","remotes":[{"alias":"@selecta","name":"selecta","entry":"/company-selecta/remoteEntry.js","shareScope":"default"},{"alias":"@panel","name":"panel","entry":"/company-panel/remoteEntry.js","shareScope":"default"}]},
		chunkMatcher: function(chunkId) {return !/^(8(264|46|550)|1042|2134|4207|4518|5975|6779|7543)$/.test(chunkId)},
		rootOutputDir: "../../",
		initialConsumes: undefined,
		bundlerRuntimeOptions: {}
	};
}